import { AccountState } from "../api";

function fmtCcy(v: number, ccy: string) {
  return `${v.toFixed(2)} ${ccy}`;
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between text-sm">
      <span className="text-fg-muted">{label}</span>
      <span className="font-mono">{value}</span>
    </div>
  );
}

export function AccountPanel({
  account,
  error,
}: {
  account: AccountState | null;
  error: string | null;
}) {
  return (
    <section className="bg-surface border border-border rounded p-4 h-full">
      <h2 className="text-sm uppercase tracking-wider text-fg-muted mb-3">Account</h2>
      {error && (
        <p className="text-danger text-sm font-mono">⚠ {error}</p>
      )}
      {!error && !account && <p className="text-fg-muted text-sm">loading…</p>}
      {account && (
        <div className="space-y-1">
          <Row label="Login" value={account.login} />
          <Row label="Server" value={account.server} />
          <Row label="Currency" value={account.currency} />
          <Row label="Leverage" value={`1:${account.leverage}`} />
          <div className="my-2 border-t border-border" />
          <Row label="Balance" value={fmtCcy(account.balance, account.currency)} />
          <Row label="Equity" value={fmtCcy(account.equity, account.currency)} />
          <Row label="Free margin" value={fmtCcy(account.margin_free, account.currency)} />
          <Row label="Open positions" value={account.open_positions} />
          <div className="my-2 border-t border-border" />
          <Row
            label="Trade allowed"
            value={account.trade_allowed ? "✓" : <span className="text-danger">✗</span>}
          />
          <Row
            label="EA / Expert"
            value={account.trade_expert ? "✓" : <span className="text-danger">✗</span>}
          />
        </div>
      )}
    </section>
  );
}
